<!-- Question 1 Starts -->
<ng-container *ngIf="isWelcome == 2">
    <section class="onboard_screen">
        <div class="logo_div">
            <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Header/logo.png" class="logo">
        </div>
        <div class="question_data_box">
            <h1>Before you get started</h1>
            <p>Check your game plan status below and update it if necessary</p>
            <div class="custom_select_box">
                <ng-select [items]="gameplanStatusList" bindLabel="option"
                    bindValue="gameplan_evaluation_confirmation_id" placeholder="Please choose"
                    [(ngModel)]="selectGpStatus" (change)="checkGpStatus(gameplanstatuserrorModal)">
                </ng-select>
            </div>
            <div class="arrows">
                <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/Arrow.svg"
                    class="left_arrow" (click)="updateWelcomeScreen(1)">
                <img *ngIf="enableArrowButton ===  false"
                    src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/Arrow.svg"
                    class="right_arrow" (click)="selectErrorGpPopup(gameplanstatuserrorModal)">
                <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/Arrow.svg"
                    class="right_arrow" (click)="updateCurrentGpStatus()">
                <!-- appearedExamScreen() -->
            </div>
            <p class="continue">Click to continue</p>
        </div>
    </section>
</ng-container>
<!-- Question 1 Ends -->

<!-- Question 2 Starts -->
<ng-contianer *ngIf="isWelcome == 3">
    <section class="subject_screen">
        <div class="logo_div">
            <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Header/logo.png" class="logo">
        </div>
        <div class="question2_data_box">
            <h1>Great! Next, select the subjects you've appeared for and update your details accordingly.</h1>
            <div class="subject_cards_box">
                <div>
                    <div class="behind-card behind-card-down" style="position: absolute" id="{{ audData.subject_id }}"
                        (click)="hideBelowFormHandler(audData.name, audData.subject_id)">
                        <div class="nick-name">{{ audData.nickName }}</div>
                        <form>
                            <div class="form_group">
                                <label class="custom_label">Exam Status</label>
                                <input type="text" placeholder="Click to select" class="form_control"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="audData.dropdownInfo.exam_status_type"
                                    (click)="selectedCard=101;examstatusModal.show();disableClick($event)">
                            </div>

                            <ng-container *ngIf="audData.dropdownInfo.exam_status_id === 4">

                                <div class="form_group">
                                    <label class="custom_label">Exam date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="audData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.audData.dropdownInfo.exam_status_id===5">

                                <div class="form_group">
                                    <label class="custom_label">Planned Month</label>
                                    <input type="month" min="{{ currentMonth }}" placeholder="DD/MM/YYYY"
                                        class="form_control" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="audData.date_of_exam" (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.audData.dropdownInfo.exam_status_id===6 ">
                                <div class="form_group">
                                    <label class="custom_label">Scheduled date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="audData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.audData.dropdownInfo.exam_status_id===7">

                                <div class="form_group">
                                    <label class="custom_label">Expected date</label>
                                    <input type="text" placeholder="DD/MM/YYYY" [disabled]="true" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="audData.expected_date"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>

                            <ng-container *ngIf="audData.dropdownInfo.exam_status_id == 4">
                                <div class="form_group">
                                    <label class="custom_label">Score</label>
                                    <input type="text" placeholder="Your score here" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="audData.score"
                                        (click)="disableClick($event)">
                                    <p class="error" style="color : red ; font-size: x-small">{{ audData.checkscore }}
                                    </p>
                                </div>
                            </ng-container>
                        </form>
                    </div>
                    <div class="behind-card behind-card-up" style="position: relative" id="{{ audData.name }}"
                        (click)="showBelowFormHandler(audData.name, audData.subject_id)">
                        <img [src]="audData.img">
                    </div>
                </div>
                <div>
                    <div class="behind-card behind-card-down" style="position: absolute" id="{{ becData.subject_id }}"
                        (click)="hideBelowFormHandler(becData.name, becData.subject_id)">

                        <div class="nick-name">{{ becData.nickName }}</div>
                        <form>
                            <div class="form_group">
                                <label class="custom_label">Exam Status</label>
                                <input type="text" placeholder="Click to select" class="form_control"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="becData.dropdownInfo.exam_status_type"
                                    (click)="selectedCard=102;examstatusModal.show();disableClick($event)">
                            </div>
                            <ng-container *ngIf="becData.dropdownInfo.exam_status_id === 4">

                                <div class="form_group">
                                    <label class="custom_label">Exam date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="becData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.becData.dropdownInfo.exam_status_id===5">

                                <div class="form_group">
                                    <label class="custom_label">Planned Month</label>
                                    <input type="month" min="{{ currentMonth }}" placeholder="DD/MM/YYYY"
                                        class="form_control" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="becData.date_of_exam" (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.becData.dropdownInfo.exam_status_id===6 ">
                                <div class="form_group">
                                    <label class="custom_label">Scheduled date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="becData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="becData.dropdownInfo.exam_status_id === 7">

                                <div class="form_group">
                                    <label class="custom_label">Expected date</label>
                                    <input type="text" placeholder="DD/MM/YYYY" [disabled]="true" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="becData.expected_date"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="becData.dropdownInfo.exam_status_id == 4">
                                <div class="form_group">
                                    <label class="custom_label">Score</label>
                                    <input type="text" placeholder="Your score here" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="becData.score"
                                        (click)="disableClick($event)">
                                    <p class="error" style="color : red; font-size: x-small">{{ becData.checkscore }}
                                    </p>
                                </div>
                            </ng-container>
                        </form>
                    </div>
                    <div class="behind-card behind-card-up" style="position: relative" id="{{ becData.name }}"
                        (click)="showBelowFormHandler(becData.name, becData.subject_id)">
                        <img [src]="becData.img">
                    </div>
                </div>
                <div>
                    <div class="behind-card behind-card-down" style="position: absolute" id="{{ farData.subject_id }}"
                        (click)="hideBelowFormHandler(farData.name, farData.subject_id)">

                        <div class="nick-name">{{ farData.nickName }}</div>
                        <form>
                            <div class="form_group">
                                <label class="custom_label">Exam Status</label>
                                <input type="text" placeholder="Click to select" class="form_control"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="farData.dropdownInfo.exam_status_type"
                                    (click)="selectedCard=103;examstatusModal.show();disableClick($event)">
                            </div>

                            <ng-container *ngIf="farData.dropdownInfo.exam_status_id === 4">

                                <div class="form_group">
                                    <label class="custom_label">Exam date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="farData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.farData.dropdownInfo.exam_status_id===5">

                                <div class="form_group">
                                    <label class="custom_label">Planned Month</label>
                                    <input type="month" min="{{ currentMonth }}" placeholder="DD/MM/YYYY"
                                        class="form_control" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="farData.date_of_exam" (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.farData.dropdownInfo.exam_status_id===6 ">
                                <div class="form_group">
                                    <label class="custom_label">Scheduled date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="farData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="farData.dropdownInfo.exam_status_id===7">

                                <div class="form_group">
                                    <label class="custom_label">Expected date</label>
                                    <input type="text" placeholder="DD/MM/YYYY" [disabled]="true" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="farData.expected_date"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="farData.dropdownInfo.exam_status_id === 4">
                                <div class="form_group">
                                    <label class="custom_label">Score</label>
                                    <input type="text" placeholder="Your score here" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="farData.score"
                                        (click)="disableClick($event)">
                                    <p class="error" style="color : red;font-size: x-small">{{ farData.checkscore }}</p>
                                </div>
                            </ng-container>
                        </form>
                    </div>
                    <div class="behind-card behind-card-up" style="position: relative" id="{{ farData.name }}"
                        (click)="showBelowFormHandler(farData.name, farData.subject_id)">
                        <img [src]="farData.img">
                    </div>
                </div>
                <div>
                    <div class="behind-card behind-card-down" style="position: absolute" id="{{ regData.subject_id }}"
                        (click)="hideBelowFormHandler(regData.name, regData.subject_id)">

                        <div class="nick-name">{{ regData.nickName }}</div>
                        <form>
                            <div class="form_group">
                                <label class="custom_label">Exam Status</label>
                                <input type="text" placeholder="Click to select" class="form_control"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="regData.dropdownInfo.exam_status_type"
                                    (click)="selectedCard=104;examstatusModal.show();disableClick($event)">
                            </div>

                            <ng-container *ngIf="regData.dropdownInfo.exam_status_id === 4 ">

                                <div class="form_group">
                                    <label class="custom_label">Exam date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="regData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.regData.dropdownInfo.exam_status_id===5">

                                <div class="form_group">
                                    <label class="custom_label">Planned Month</label>
                                    <input type="month" min="{{ currentMonth }}" placeholder="DD/MM/YYYY"
                                        class="form_control" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="regData.date_of_exam" (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.regData.dropdownInfo.exam_status_id===6 ">
                                <div class="form_group">
                                    <label class="custom_label">Scheduled date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="regData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="regData.dropdownInfo.exam_status_id===7">

                                <div class="form_group">
                                    <label class="custom_label">Expected date</label>
                                    <input type="text" placeholder="DD/MM/YYYY" [disabled]="true" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="regData.expected_date"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container *ngIf="regData.dropdownInfo.exam_status_id == 4">
                                <div class="form_group">
                                    <label class="custom_label">Score</label>
                                    <input type="text" placeholder="Your score here" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="regData.score"
                                        (click)="disableClick($event)">
                                    <p class="error" style="color : red;font-size: x-small">{{ regData.checkscore }}</p>
                                </div>
                            </ng-container>
                        </form>
                    </div>
                    <div class="behind-card behind-card-up" style="position: relative" id="{{ regData.name }}"
                        (click)="showBelowFormHandler(regData.name, regData.subject_id)">
                        <img [src]="regData.img">
                    </div>
                </div>

            </div>

            <div class="arrows">
                <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/Arrow.svg"
                    class="left_arrow" (click)="updateWelcomeScreen(2)">
                <img *ngIf="enableArrowButton ===  true"
                    src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/Arrow.svg"
                    class="right_arrow" (click)="updateExamStatus(gameplanstatuserrorModal)">
            </div>
            <p class="continue">Click to continue</p>
        </div>
    </section>
</ng-contianer>
<!-- Question 2 Ends -->

<!-- Question 3 Starts -->
<ng-contianer *ngIf="isWelcome == 4">
    <section class="preparing_subject_screen">
        <div class="logo_div">
            <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Header/logo.png" class="logo">
        </div>
        <div class="question3_data_box">
            <h1>Awesome! Now, let's pick the subject you're currently preparing for!</h1>

            <div class="subject_cards_box">
                <!-- <ng-contianer *ngIf="audData.exam_status_id != 4"> -->

                <div *ngIf="audData.exam_status_id <4">
                    <div class="behind-card behind-card-down" style="position: absolute" id="{{ audData.subject_id }}"
                        (click)="hideBelowFormHandler(audData.name, audData.subject_id)">

                        <div class="nick-name">{{ audData.nickName }}</div>
                        <form *ngIf="!audData.prioritizeWarning">
                            <div class="form_group">
                                <label class="custom_label">Exam Status</label>
                                <input type="text" placeholder="Click to select" class="form_control"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="audData.dropdownInfo.exam_status_type"
                                    (click)="selectedCard=101;examstatusModal.show();disableClick($event)">
                            </div>

                            <ng-container
                                *ngIf="this.audData.dropdownInfo.exam_status_id===0||this.audData.dropdownInfo.exam_status_id===1 || this.audData.dropdownInfo.exam_status_id===2 || this.audData.dropdownInfo.exam_status_id===5">

                                <div class="form_group">
                                    <label class="custom_label">Planned Month</label>
                                    <input type="month" min="{{ currentMonth }}" placeholder="DD/MM/YYYY"
                                        class="form_control" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="audData.date_of_exam" (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="this.audData.dropdownInfo.exam_status_id===3 || this.audData.dropdownInfo.exam_status_id===6 ">
                                <div class="form_group">
                                    <label class="custom_label">Scheduled date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="audData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="(previousGpstatus == 6 || previousGpstatus == 16) &&audData.nts_expire_date !==null">
                                <div class="form_group">
                                    <label class="custom_label">NTS Expire date</label>
                                    <input type="date" min="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="audData.nts_expire_date "
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                        </form>

                        <ng-container *ngIf="audData.prioritizeWarning">
                            <!-- Error Code Starts-->
                            <div class="error_msg" (click)="disableClick($event)">
                                <!-- <div id="alert-lottie-img" class="alert-lottie-class"></div> -->
                                <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Launchpad/error.svg"
                                    class="alert-lottie-class">
                                <p>Prioritize and avoid spreading your attention too thin! If you are
                                    confident, go ahead and choose another subject!</p>
                                <div class="btns_box">
                                    <button type="button" class="continue_anyway" (click)="showSubjectCard(101);">
                                        Continue anyway </button>
                                    <p (click)="hideBelowFormHandler(audData.name, audData.subject_id)">Cancel</p>
                                </div>
                            </div>
                            <!-- Error Code Ends-->
                        </ng-container>
                    </div>
                    <div class="behind-card behind-card-up" style="position: relative" id="{{ audData.name }}"
                        (click)="showBelowFormHandler(audData.name, audData.subject_id)">
                        <img [src]="audData.img">
                    </div>
                </div>
                <!-- </ng-contianer> -->

                <!-- </div> -->
                <!-- <div class="subject_cards_box"> -->
                <!-- <ng-contianer *ngIf="becData.exam_status_id != 4"> -->

                <div *ngIf="becData.exam_status_id <4">
                    <div class="behind-card behind-card-down" style="position: absolute" id="{{ becData.subject_id }}"
                        (click)="hideBelowFormHandler(becData.name, becData.subject_id)">

                        <div class="nick-name">{{ becData.nickName }}</div>
                        <form *ngIf="!becData.prioritizeWarning">
                            <div class="form_group">
                                <label class="custom_label">Exam Status</label>
                                <input type="text" placeholder="Click to select" class="form_control"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="becData.dropdownInfo.exam_status_type"
                                    (click)="selectedCard=102;examstatusModal.show();disableClick($event)">
                            </div>

                            <ng-container
                                *ngIf="this.becData.dropdownInfo.exam_status_id===0||this.becData.dropdownInfo.exam_status_id===1 || this.becData.dropdownInfo.exam_status_id===2 || this.becData.dropdownInfo.exam_status_id===5">

                                <div class="form_group">
                                    <label class="custom_label">Planned Month</label>
                                    <input type="month" min={{currentMonth}} placeholder="DD/MM/YYYY"
                                        class="form_control" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="becData.date_of_exam" (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="this.becData.dropdownInfo.exam_status_id===3 || this.becData.dropdownInfo.exam_status_id===6 ">
                                <div class="form_group">
                                    <label class="custom_label">Scheduled date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="becData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>

                            <ng-container
                                *ngIf="(previousGpstatus == 6 || previousGpstatus == 16 )&& becData.nts_expire_date !== null">
                                <div class="form_group">
                                    <label class="custom_label">NTS Expire date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="becData.nts_expire_date "
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                        </form>
                        <ng-container *ngIf="becData.prioritizeWarning">
                            <!-- Error Code Starts-->
                            <div class="error_msg" (click)="disableClick($event)">
                                <!-- <div id="alert-lottie-img" class="alert-lottie-class"></div> -->
                                <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Launchpad/error.svg"
                                    class="alert-lottie-class">
                                <p>Prioritize and avoid spreading your attention too thin! If you are
                                    confident, go ahead and choose another subject!</p>
                                <div class="btns_box">
                                    <button type="button" class="continue_anyway" (click)="showSubjectCard(102);">
                                        Continue anyway </button>
                                    <p (click)="hideBelowFormHandler(becData.name, becData.subject_id)">Cancel</p>
                                </div>
                            </div>
                            <!-- Error Code Ends-->
                        </ng-container>
                    </div>

                    <div class="behind-card behind-card-up" style="position: relative" id="{{ becData.name }}"
                        (click)="showBelowFormHandler(becData.name, becData.subject_id)">
                        <img [src]="becData.img">
                    </div>
                </div>
                <!-- </ng-contianer> -->

                <!-- </div> -->
                <!-- <div class="subject_cards_box"> -->
                <!-- <ng-contianer *ngIf="farData.exam_status_id != 4"> -->

                <div *ngIf="farData.exam_status_id <4">
                    <div class="behind-card behind-card-down" style="position: absolute" id="{{ farData.subject_id }}"
                        (click)="hideBelowFormHandler(farData.name, farData.subject_id)">

                        <div class="nick-name">{{ farData.nickName }}</div>
                        <form *ngIf="!farData.prioritizeWarning">
                            <div class="form_group">
                                <label class="custom_label">Exam Status</label>
                                <input type="text" placeholder="Click to select" class="form_control"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="farData.dropdownInfo.exam_status_type"
                                    (click)="selectedCard=103;examstatusModal.show();disableClick($event)">
                            </div>

                            <ng-container
                                *ngIf="this.farData.dropdownInfo.exam_status_id===0||this.farData.dropdownInfo.exam_status_id===1 || this.farData.dropdownInfo.exam_status_id===2 || this.farData.dropdownInfo.exam_status_id===5">

                                <div class="form_group">
                                    <label class="custom_label">Planned Month</label>
                                    <input type="month" min={{currentMonth}} placeholder="DD/MM/YYYY"
                                        class="form_control" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="farData.date_of_exam" (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="this.farData.dropdownInfo.exam_status_id===3 || this.farData.dropdownInfo.exam_status_id===6 ">
                                <div class="form_group">
                                    <label class="custom_label">Scheduled date</label>
                                    <input type="date" min="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="farData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>

                            <ng-container
                                *ngIf="(previousGpstatus == 6 || previousGpstatus == 16 )&&farData.nts_expire_date !==null">
                                <div class="form_group">
                                    <label class="custom_label">NTS Expire date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="farData.nts_expire_date"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <!-- <ng-container *ngIf="farData.exam_status_id === 4 || farData.exam_status===7">

                                    <div class="form_group">
                                        <label class="custom_label">Exam date</label>
                                        <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY"
                                            class="form_control" [ngModelOptions]="{standalone: true}"
                                            [(ngModel)]="farData.date_of_exam" (click)="disableClick($event)">
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="farData.exam_status===7">

                                    <div class="form_group">
                                        <label class="custom_label">Expected date</label>
                                        <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" disable=true
                                            class="form_control" [ngModelOptions]="{standalone: true}"
                                            [(ngModel)]="farData.date_of_exam" (click)="disableClick($event)">
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="farData.exam_status_id === 4">{{farData.exam_status_id}}
                                    <div class="form_group">
                                        <label class="custom_label">Score</label>
                                        <input type="text" placeholder="Your score here" class="form_control"
                                            [ngModelOptions]="{standalone: true}" [(ngModel)]="farData.score"
                                            (click)="disableClick($event)" (valueChange)="onInputChange($event)">
                                        <p class="error">{{ scoreError }}</p>
                                    </div>
                                </ng-container> -->
                        </form>

                        <ng-container *ngIf="farData.prioritizeWarning">
                            <!-- Error Code Starts-->
                            <div class="error_msg" (click)="disableClick($event)">
                                <!-- <div id="alert-lottie-img" class="alert-lottie-class"></div> -->
                                <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Launchpad/error.svg"
                                    class="alert-lottie-class">
                                <p>Prioritize and avoid spreading your attention too thin! If you are
                                    confident, go ahead and choose another subject!</p>
                                <div class="btns_box">
                                    <button type="button" class="continue_anyway" (click)="showSubjectCard(103);">
                                        Continue anyway </button>
                                    <p (click)="hideBelowFormHandler(farData.name, farData.subject_id)">Cancel</p>
                                </div>
                            </div>
                            <!-- Error Code Ends-->
                        </ng-container>
                    </div>
                    <div class="behind-card behind-card-up" style="position: relative" id="{{ farData.name }}"
                        (click)="showBelowFormHandler(farData.name, farData.subject_id)">
                        <img [src]="farData.img">
                    </div>
                </div>
                <!-- </ng-contianer> -->
                <!-- </div> -->
                <!-- <ng-contianer *ngIf="regData.exam_status_id != 4"> -->
                <!-- <div class="subject_cards_box"> -->
                <div *ngIf="regData.exam_status_id <4">
                    <div class="behind-card behind-card-down" style="position: absolute" id="{{ regData.subject_id }}"
                        (click)="hideBelowFormHandler(regData.name, regData.subject_id)">

                        <div class="nick-name">{{ regData.nickName }}</div>
                        <form *ngIf="!regData.prioritizeWarning">
                            <div class="form_group">
                                <label class="custom_label">Exam Status</label>
                                <input type="text" placeholder="Click to select" class="form_control"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="regData.dropdownInfo.exam_status_type"
                                    (click)="selectedCard=104;examstatusModal.show();disableClick($event)">
                            </div>

                            <ng-container
                                *ngIf="this.regData.dropdownInfo.exam_status_id===0||this.regData.dropdownInfo.exam_status_id===1 || this.regData.dropdownInfo.exam_status_id===2 || this.regData.dropdownInfo.exam_status_id===5">

                                <div class="form_group">
                                    <label class="custom_label">Planned Month</label>
                                    <input type="month" min={{currentMonth}} placeholder="DD/MM/YYYY"
                                        class="form_control" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="regData.date_of_exam" (click)="disableClick($event)">
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="this.regData.dropdownInfo.exam_status_id===3 || this.regData.dropdownInfo.exam_status_id===6 ">
                                <div class="form_group">
                                    <label class="custom_label">Scheduled date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="regData.date_of_exam"
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>

                            <ng-container
                                *ngIf="(previousGpstatus == 6 || previousGpstatus == 16) &&regData.nts_expire_date !== null">
                                <div class="form_group">
                                    <label class="custom_label">NTS Expire date</label>
                                    <input type="date" max="{{todayDay}}" placeholder="DD/MM/YYYY" class="form_control"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="regData.nts_expire_date "
                                        (click)="disableClick($event)">
                                </div>
                            </ng-container>

                        </form>

                        <ng-container *ngIf="regData.prioritizeWarning">
                            <!-- Error Code Starts-->
                            <div class="error_msg" (click)="disableClick($event)">
                                <!-- <div id="alert-lottie-img" class="alert-lottie-class"></div> -->
                                <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Launchpad/error.svg"
                                    class="alert-lottie-class">
                                <p>Prioritize and avoid spreading your attention too thin! If you are
                                    confident, go ahead and choose another subject!</p>
                                <div class="btns_box">
                                    <button type="button" class="continue_anyway" (click)="showSubjectCard(104);">
                                        Continue anyway </button>
                                    <p (click)="hideBelowFormHandler(regData.name, regData.subject_id)">Cancel</p>
                                </div>
                            </div>
                            <!-- Error Code Ends-->
                        </ng-container>
                    </div>
                    <div class="behind-card behind-card-up" style="position: relative" id="{{ regData.name }}"
                        (click)="showBelowFormHandler(regData.name, regData.subject_id)">
                        <img [src]="regData.img">
                    </div>
                </div>
                <!-- </ng-contianer> -->

            </div>


            <div class="arrows">
                <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/Arrow.svg"
                    class="left_arrow" (click)="updateWelcomeScreen(2)">
                <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/Arrow.svg"
                    class="right_arrow" (click)="updateExamStatus(gameplanstatuserrorModal)">
            </div>
            <p class="continue">Click to continue</p>
        </div>
    </section>
</ng-contianer>
<!-- Question 3 Ends -->



<!-- Exam Status Modal -->
<div mdbModal #examstatusModal="mdbModal" class="modal custom_modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <button type="button" class="close pull-right close_btn" aria-label="Close"
                (click)="examstatusModal.hide()">
                <img
                    src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/close.svg">
            </button>
            <div class="exam_status_select_box">
                <ng-select placeholder="Please choose" [(ngModel)]="selectExamStatus"
                    (change)="examstatusModal.hide();changeDropDown(gameplanstatuserrorModal)">
                    <ng-option *ngFor="let item of examStatusList" [value]="item.exam_status_id">
                        {{item.exam_status_type}}
                    </ng-option>
                </ng-select>
            </div>
        </div>
    </div>
</div>

<!-- Gameplan Status Error Modal Starts -->
<div mdbModal #gameplanstatuserrorModal="mdbModal" class="modal gameplan_error_modal fade bottom" tabindex="-1"
    role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-bottom full_width" role="document">
        <div class="modal-content">
            <div class="modal-body border-0">
                <button type="button" class="close pull-right error_close_btn" aria-label="Close"
                    (click)="gameplanstatuserrorModal.hide()">
                    <img
                        src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/close.svg">
                </button>

                <div style="text-align: center;">
                    <div id="error-lottie" class="error_lottie"></div>
                    <p *ngIf="showErrorPopup != 1 && showErrorPopup != 2" class="gameplan_error_text">
                        {{commonErrorMsg}} </p>

                    <!-- Error 1 -->
                    <p *ngIf="showErrorPopup == 1" class="gameplan_error_text"> {{gpErrorMsg}} </p>
                    <!-- Error 2 -->
                    <p *ngIf="showErrorPopup == 2" class="gameplan_error_text_bold">{{examErrorMsg}}</p>
                    <!-- <button *ngIf="showErrorPopup == 2" type="button" class="edit_btn_new"
                        (click)="gameplanstatuserrorModal.hide();updateWelcomeScreen(2)"><img
                            src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Gameplan-Status/edit.svg"
                            style="width: 20px;"> Edit</button> -->
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Gameplan Status Error Modal Ends -->